import { NumberInput, NumberInputEvent } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

type NumberInputProps = React.ComponentProps<typeof NumberInput>;

export type FormNumberInputFieldProps = Omit<NumberInputProps, 'value' | 'error' | 'onBlur'> &
    Partial<Pick<NumberInputProps, 'onChange'>> &
    ControllerProps<number | undefined>;

export const FormNumberInputField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormNumberInputFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler<
        NumberInputEvent,
        number | undefined
    >({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: handleChange,
        value,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <NumberInput {...props} />;
};
